import { useTranslation } from 'react-i18next';

import { ConfirmationModal } from '@/modules/common/components/modals/confirmation-modal';

interface InvoiceInProgressModalProps {
  isOpen: boolean;
  isUpdating: boolean;
  onClose: () => void;
}

export const InvoiceInProgressModal = ({
  isOpen,
  isUpdating,
  onClose,
}: InvoiceInProgressModalProps) => {
  const { t } = useTranslation(['authenticated.invoices', 'common'], {
    keyPrefix: 'modals.invoiceInProgress',
  });
  const contentKey = isUpdating ? 'update' : 'create';

  return (
    <ConfirmationModal
      onClose={onClose}
      open={isOpen}
      confirmText={t('submit')}
      onConfirm={onClose}
      title={t(`${contentKey}.title`)}
      cancelText={t('cancel')}
      confirmVariant="default"
      hideCloseIcon
      hideCancelButton
    >
      <div className="text-sm text-muted-foreground">
        <p>{t(`${contentKey}.description`)}</p>
      </div>
    </ConfirmationModal>
  );
};
